import { Platform } from 'react-native';

export enum ShiftSuiteMenuItem {
  propertyManager = 'Property Manager',
  contactUs = 'Contact Us',
  activityFeed = 'Activity Feed',
  communityNews = 'Community News',
  gallery = 'Gallery',
  communityCalendar = 'Community Calendar',
  ledger = 'Ledger',
  documentLibrary = 'Document Library',
  serviceRequests = 'Service Requests',
  amenityBookings = 'Amenity Bookings',
  statusCertificate = 'Status Certificate',
  myProfile = 'My Profile',
  feedback = 'Feedback',
  signOut = 'Sign Out',
  contest = 'Contest',
}

export enum ShiftSuiteMenuItemId {
  propertyManager = 'Property Manager',
  contactUs = 'Contact Us',
  activityFeed = 'Activity Feed',
  communityNews = 'News',
  gallery = 'Gallery',
  communityCalendar = 'communityCalendar',
  ledger = 'Ledger',
  documentLibrary = 'documentLibrary',
  serviceRequests = 'serviceRequests',
  amenityBookings = 'amenityBookings',
  statusCertificate = 'statusCertificate',
  myProfile = 'myProfile',
  feedback = 'feedback',
  signOut = 'signOut',
  contest = 'contest',
}

const ShiftSuiteIcon: any = {
  community_news: require('../assets/community_news.png'),
  gallery: require('../assets/gallery.png'),
  community_calendar: require('../assets/community_calendar.png'),
  service_requests: require('../assets/service_requests.png'),
  contact_us: require('../assets/contact_us.png'),
  ledger: require('../assets/ledger.png'),
  feedback_icon: require('../assets/feedback_icon.png'),
  sign_out: require('../assets/sign_out.png'),
  documents: require('../assets/documents.png'),
  status_certificate: require('../assets/status_certificate.png'),
};

export function iconName(name: string) {
  if (Platform.OS === 'android') {
    return ShiftSuiteIcon[name];
  }
  if (Platform.OS === 'web') {
    return ShiftSuiteIcon[name];
  }
  return name;
}

const ShiftSuiteMenuItems = [
  {
    id: ShiftSuiteMenuItemId.serviceRequests,
    title: ShiftSuiteMenuItem.serviceRequests,
    icon: iconName('service_requests'),
    local: true,
  },
  {
    id: ShiftSuiteMenuItemId.ledger,
    title: ShiftSuiteMenuItem.ledger,
    icon: iconName('ledger'),
    local: true,
  },
  {
    id: ShiftSuiteMenuItemId.communityNews,
    title: ShiftSuiteMenuItem.communityNews,
    icon: iconName('community_news'),
    local: true,
  },
  {
    id: ShiftSuiteMenuItemId.gallery,
    title: ShiftSuiteMenuItem.gallery,
    icon: iconName('gallery'),
    local: true,
  },
  {
    id: ShiftSuiteMenuItemId.communityCalendar,
    title: ShiftSuiteMenuItem.communityCalendar,
    icon: iconName('community_calendar'),
    local: true,
  },
  // {
  //   id: ShiftSuiteMenuItemId.statusCertificate,
  //   title: ShiftSuiteMenuItem.statusCertificate,
  //   icon: iconName('status_certificate'),
  //   local: true,
  // },
  {
    id: ShiftSuiteMenuItemId.propertyManager,
    title: ShiftSuiteMenuItem.propertyManager,
    icon: iconName('service_requests'),
    local: true,
  },
  {
    id: ShiftSuiteMenuItemId.contactUs,
    title: ShiftSuiteMenuItem.contactUs,
    icon: iconName('contact_us'),
    local: true,
  },
  // {
  //   id: ShiftSuiteMenuItemId.activityFeed,
  //   title: ShiftSuiteMenuItem.activityFeed,
  //   icon: iconName('activity_feed'),
  // },
  // {
  //   id: ShiftSuiteMenuItemId.documentLibrary,
  //   title: ShiftSuiteMenuItem.documentLibrary,
  //   icon: iconName('documents'),
  // },
  // {
  //   id: ShiftSuiteMenuItemId.amenityBookings,
  //   title: ShiftSuiteMenuItem.amenityBookings,
  //   icon: iconName('amenity_bookings'),
  // },
  // {
  //   id: ShiftSuiteMenuItemId.myProfile,
  //   title: ShiftSuiteMenuItem.myProfile,
  //   icon: iconName('profile'),
  // },
  // {
  //   id: ShiftSuiteMenuItemId.feedback,
  //   title: ShiftSuiteMenuItem.feedback,
  //   icon: iconName('feedback_icon'),
  //   local: true,
  // },
  {
    id: ShiftSuiteMenuItemId.contest,
    title: ShiftSuiteMenuItem.contest,
    icon: iconName('documents'),
    local: true,
  },
  {
    id: ShiftSuiteMenuItemId.signOut,
    title: ShiftSuiteMenuItem.signOut,
    icon: iconName('sign_out'),
    local: true,
  },
];

export default ShiftSuiteMenuItems;
